import React from 'react';
import BlogInfo from '../../../components/Shared/BlogInfo';

const AdminBlogInfo = ({ blog }) => <BlogInfo blog={blog} />;

export default AdminBlogInfo;
